//Material-UI
import React, { useEffect } from 'react';

import { isUser, isStudent } from './../../app/util';
import UnauthorizedPage from "./../../components/util/ProtectedRoute/UnauthorizedPage";

import { useDispatch, useSelector } from 'react-redux';

// Users
import UserHome from '../user/UserHome/UserHome';

function Home() {
  const appState = useSelector((state)=>state.app);

  return (
    <>
      {
        isUser(appState.me) && isStudent(appState.me)
        ? <><UserHome /><br /></>
        : <UnauthorizedPage />
      }
    </>
  );
}

export default Home;
